import styled from '@emotion/styled'
import { calcRem } from '../../../__styling'
import { AmuseLabsIframe } from '../components/AmuseLabsIframe'

export const PuzzleIframe = styled(AmuseLabsIframe)(({ theme }) => ({
    marginBottom: calcRem(theme.margins.xl),
}))
